import { create } from 'zustand'

import { FormattedOperator } from '@/types/operator'

import type { UserOperatorsStore } from './useOperatorsStore.types'

export const useOperatorsStore = create<UserOperatorsStore>((set) => ({
  operators: [],
  searchOperatorQuery: '',
  sortBy: '',
  setOperators: (operators: FormattedOperator[]) => {
    set({
      operators
    })
  },
  setSearchOperatorQuery: (searchOperatorQuery: string) => {
    set({
      searchOperatorQuery
    })
  },
  setSortBy: (sortBy: string) => {
    set({
      sortBy
    })
  }
}))
